import { render } from "./supervisionlimpieza.vue?vue&type=template&id=74b51924&scoped=true"
import script from "./supervisionlimpieza.vue?vue&type=script&lang=js"
export * from "./supervisionlimpieza.vue?vue&type=script&lang=js"

import "./supervisionlimpieza.vue?vue&type=style&index=0&id=74b51924&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b51924"]])

export default __exports__